<template>
  <div class="sign">
    <swipeComponents></swipeComponents>
    <template v-if="isSigned">
      <van-cell-group>
        <van-field
          v-model="form.distance"
          label="所属区"
          :readonly="isSigned"
          :label-width="labelWidth"
        />
        <van-field
          v-model="form.applyUserName"
          label="姓名"
          :readonly="isSigned"
          :label-width="labelWidth"
        />
        <van-field
          v-model="form.applyDuty"
          label="职务"
          :readonly="isSigned"
          :label-width="labelWidth"
        />
        <van-field
          v-model="form.applyCompany"
          label="单位/孵化器名称"
          :readonly="isSigned"
          :label-width="labelWidth"
        />
        <van-field
          v-model="form.applyPhone"
          label="电话"
          :readonly="isSigned"
          :label-width="labelWidth"
        />
      </van-cell-group>
    </template>
    <template v-if="!isSigned">
      <div class="nodata">
        <img src="@/assets/image/nodata.png" alt="" />
        <div class="nodata-text">您还没有报名~</div>
      </div>
    </template>
    <div class="btns">
      <van-button type="info" block to="sign">
        {{ isSigned ? "前往修改" : "前往报名" }}
      </van-button>
    </div>
    <noticeBox></noticeBox>
  </div>
</template>

<script>
import { Field, CellGroup, Button } from "vant";
import { getApplyInfo } from "@/api";
import swipeComponents from "@/components/swipe.vue";
import noticeBox from "@/components/Notice.vue";
export default {
  name: "Sign",
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    swipeComponents,
    noticeBox
  },
  data() {
    return {
      labelWidth: "120",
      isSigned: false,
      form: {
        distance: "",
        applyUserName: "",
        applyDuty: "",
        applyCompany: "",
        applyPhone: ""
      }
    };
  },
  methods: {
    goGetApplyInfo() {
      getApplyInfo()
        .then(res => {
          // console.log(res);
          if (res.status == 200) {
            this.form.applyUserName = res.data.applyUserName;
            this.form.applyDuty = res.data.applyDuty;
            this.form.applyCompany = res.data.applyCompany;
            this.form.applyPhone = res.data.applyPhone;
            this.form.distance = res.data.distance;
            if (res.data.applyUserName) {
              this.isSigned = true;
            }
          }
        })
        .catch(() => {});
    }
  },
  created() {
    this.goGetApplyInfo();
  }
};
</script>

<style lang="stylus" scoped>
.sign
  .btns
    padding 0 15px
    margin-top 40px
    .van-button
      margin-top 10px
</style>
